export default __webpack_public_path__ + "2473876ac55c7a76a32f239a587d985a.png";